import { types, actions } from "reducers/requestAndComplaints";
import * as requestsAndClaimsMiddleware from "middleware/requestAndComplaints";
import { call, put, takeLatest } from "redux-saga/effects";

const sagas = [takeLatest(types.LIST_REQUESTS_AND_CLAIMS_REQUEST, requestAndClaimListRequest)];

export default sagas;

function* requestAndClaimListRequest({ filters, onFinish }) {
    const response = yield call(requestsAndClaimsMiddleware.listRequestsAndClaims, filters);
    if (response && response.status === 200) {
        yield put(actions.listRequestsAndClaimsSuccess(response.data.data));
    }

    if (typeof onFinish === "function") {
        onFinish();
    }
}
